var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('search-bar'),_vm._v(" "),_c('banner-nav'),_vm._v(" "),_c('nav-bar'),_vm._v(" "),_c('news'),_vm._v(" "),_c('xnew-goods'),_vm._v(" "),_c('news2'),_vm._v(" "),_c('boxnav'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('goodslist')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9542caae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelloWorld.vue
// module id = null
// module chunks = 